import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'product'

const ProductModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default ProductModule



// WEBPACK FOOTER //
// ./src/store/module/product/index.js